export const ConfigurationRepositoryToken = Symbol('ConfigurationRepository');
export const DomainGetterToken = Symbol('DomainGetter');
